/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Construct from 'can/construct/construct';
import can from 'can';
import _ from 'lodash';
import appConfig from 'scripts/app-config';
import 'can/construct/super/super';
import 'can/construct/proxy/proxy';

export default Construct.extend({
    init: function () {
        this._ = _;
        this.$ = can.$;
        this.appConfig = appConfig;
        this.apiUrl = '';
        this.apiLoading = false;
        this.apiLoaded = false;
        this.autoResolve = true;
        this.socialAwaiting = can.Deferred();
    },

    initialize: function (options) {
        this.options = can.extend({}, options);
        if (!this.isApiAvailable()) {
            this.loadApi();
        }
    },

    /**
     * This is abstract method and it should be implemented in derived class.
     * @return {boolean} api available
     */
    isApiAvailable: function () {
        return false;
    },

    getApiUrl: function () {
        return this.apiUrl;
    },

    loadApi: function () {
        if (!this.apiLoaded) {
            if (this.isApiAvailable()) {
                this._onApiLoaded();
            } else if (!this.apiLoading) {
                this.apiLoading = true;
                can.ajax({
                    url: this.getApiUrl(),
                    dataType: 'script',
                    cache: true
                }).then(function () {
                    this._onApiLoaded();
                }.bind(this));
            }
        }
    },

    _onApiLoaded: function () {
        this.apiLoading = false;
        this.apiLoaded = true;
        this.onApiLoaded.apply(this, arguments);
        if (this.autoResolve) {
            this.socialAwaiting.resolve();
        }
    },

    onApiLoaded: function () {
        /* */
    }
}, {});
